// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"a5f95434","453":"127be8e2","597":"27510562","713":"10fb2fe5"}[chunkId] + ".chunk.js";
};